import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetMagiisAutocompleteCommand
    extends IRequestCommand<
    IMagiisGetAutocompleteResponse,
    ErrorDetails,
    IMagiisGetAutocompleteRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.GET;

    public override setParameters(parameters: IMagiisGetAutocompleteRequest) {
        this._commandBody = parameters;
        this.urlSections.push('places');
        this.urlSections.push('getAutocompleteMagiis');
        this.paramsSections.push(`search=${parameters.search}`);
        if(parameters.latitude && parameters.longitude){
          this.paramsSections.push(`latitude=${parameters.latitude}`);
          this.paramsSections.push(`longitude=${parameters.longitude}`);
          this.paramsSections.push(`radius=${parameters.radius}`);
        }
        if(parameters.language){
          this.paramsSections.push(`language=${parameters.language}`);
        }
        this.composeUrl();
    }
}

export interface IMagiisGetAutocompleteRequest extends ICommandParameters {
    search: string;
    latitude?: number;
    longitude?: number;
    radius?: number;
    language?: string;
}

export interface IMagiisGetAutocompleteResponse extends ICommandResponse {
    place_id: string;
    description: string;
    types: string;
}
